import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function AdminProtectedRoute({ children }) {
  const [status, setStatus] = useState('checking'); // checking | valid | invalid

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setStatus('invalid');
      return;
    }

    fetch(`${API_BASE}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => {
        if (json.success && json.data.role === 'ADMIN') {
          setStatus('valid');
        } else {
          localStorage.removeItem('adminToken');
          setStatus('invalid');
        }
      })
      .catch(() => setStatus('invalid'));
  }, []);

  if (status === 'checking') {
    return <p className="text-center py-40 text-[#64748b]">Verifying access...</p>;
  }

  if (status === 'invalid') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}